"use strict";
// INTERFACES RELATING TO THE PEDAGOGICAL RESOURCES MANAGEMENT PAGE
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRHierarchyIds = exports.PRHierarchy = void 0;
/**
 * Describes the position in the data hierarchy of an item
 */
var PRHierarchy;
(function (PRHierarchy) {
    PRHierarchy["Modules"] = "modules";
    PRHierarchy["Objectives"] = "objectives";
})(PRHierarchy = exports.PRHierarchy || (exports.PRHierarchy = {}));
var PRHierarchyIds;
(function (PRHierarchyIds) {
    PRHierarchyIds["ModuleIds"] = "moduleIds";
    PRHierarchyIds["ObjectiveIds"] = "objectiveIds";
})(PRHierarchyIds = exports.PRHierarchyIds || (exports.PRHierarchyIds = {}));
